import { NgModule } from '@angular/core';
import { LayoutComponent } from './layout/layout.component';
import { RouterModule, Routes, UrlMatchResult, UrlSegment } from '@angular/router';
import { LearnizGuard } from '@jump-tools-front/shared';

const routes: Routes = [
  {
    matcher: scormMatcher,
    redirectTo: '/landing-page',
  },
  {
    path: 'error',
    loadChildren: () => import('../features/error-page/error-page.module').then(m => m.ErrorPageModule),
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [LearnizGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'landing-page',
      },
      {
        path: 'landing-page',
        loadChildren: () => import('../features/landing-page/landing-page.module').then(m => m.LandingPageModule),
      },
      {
        path: 'chapter',
        loadChildren: () => import('../features/chapter/chapter.module').then(m => m.ChapterModule),
      },
      {
        path: 'error',
        loadChildren: () => import('../features/error-page/error-page.module').then(m => m.ErrorPageModule),
      },
      { path: '**', redirectTo: '/error' },
    ],
  },
  { path: '**', redirectTo: '/error' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      enableTracing: false,
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class CoreRoutingModule {}

export function scormMatcher(segments: UrlSegment[] /*group: UrlSegmentGroup, route: Route*/): UrlMatchResult {
  if (segments.some(s => s.path === 'index.html')) {
    return { consumed: segments };
  }
  return null;
}
